/**
 * Copyright (c) 2017-present, Tomaruba, Inc.
 * All rights reserved.
 *
 */
import { ReduceStore } from 'flux/utils'
import AppDispatcher from '../../core/AppDispatcher'
import { List } from 'immutable'
import MonthlyClosingEvent from '../../event/MonthlyClosingEvent'
import { MonthlyClosingDetailState } from '../state/MonthlyClosingDetailState'

class MonthlyClosingDetailsStore extends ReduceStore {
  constructor() {
    super(AppDispatcher)
  }

  getInitialState() {
    return List.of()
  }

  reduce(state, action) {
    const payload = action.payload

    switch (action.type) {
      case MonthlyClosingEvent.fetchOne:
        if (payload.monthly_closing_details && payload.monthly_closing_details.length > 0) {
          const detail = payload.monthly_closing_details.map(detail => new MonthlyClosingDetailState(detail))
          return List(detail)
        }
        return state

      case MonthlyClosingEvent.addDetail:
        return state.push(new MonthlyClosingDetailState())

      case MonthlyClosingEvent.onEditDetail:
        const details = state.setIn([payload.index, payload.name], payload.value)
        return List(details)

      case MonthlyClosingEvent.onDeleteDetail:
        return state.remove(payload.index)

      case MonthlyClosingEvent.onClear:
        return state.clear()

      default:
        return state
    }
  }
}

export default new MonthlyClosingDetailsStore()
